(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  var loadProductRecommendationsIntoSection = function() {
    // Look for an element with class 'product-recommendations'
    var productRecommendationsSection = document.querySelector(".product-recommendations");
    var recommended_url = productRecommendationsSection.dataset.baseUrl;;

    if (productRecommendationsSection === null) { return; }
    // Read product id from data attribute
    var productId = productRecommendationsSection.dataset.productId;
    // Read limit from data attribute
    var limit = productRecommendationsSection.dataset.limit;
    // Build request URL
    var requestUrl = recommended_url + '?section_id=product-recommendations&limit=' + limit + '&product_id=' + productId;

    // Create request and submit it using Ajax
    var request = new XMLHttpRequest();
    request.open("GET", requestUrl);
    request.onload = function() {
      if (request.status >= 200 && request.status < 300) {
        var container = document.createElement("div");
        container.innerHTML = request.response;
        productRecommendationsSection.parentElement.innerHTML = container.querySelector(".product-recommendations").innerHTML;
      }
    };
    request.send();
  };
  document.addEventListener("shopify:section:load", function(event) {
    if (event.detail.sectionId === "product-recommendations") {
      loadProductRecommendationsIntoSection();
    }
  });
  // Fetching the recommendations on page load
  loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["three-product-collection"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function () {
        // Initialize slick for each carousel
        $('.slick-carousel').each(function () {
            var $carousel = $(this);
            
            $carousel.slick({
                slidesToShow: 3,
                slidesToScroll: 1,
                dots: false,
                arrows: false,
                infinite: false,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 1,
                        },
                    },
                    {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                        },
                    },
                ],
            });

            // Update buttons based on current slide for each carousel
            function updateButtonState() {
                var currentSlide = $carousel.slick("slickCurrentSlide");
                var totalSlides = $carousel.slick("getSlick").slideCount;

                // Find the closest .carousel-container to the current .slick-carousel
                var $carouselContainer = $carousel.closest(".carousel-container");

                if (currentSlide === 0) {
                    $carouselContainer.find(".prev-btn").addClass("slick-disabled");
                } else {
                    $carouselContainer.find(".prev-btn").removeClass("slick-disabled");
                }

                if (currentSlide === totalSlides - 1) {
                    $carouselContainer.find(".next-btn").addClass("slick-disabled");
                } else {
                    $carouselContainer.find(".next-btn").removeClass("slick-disabled");
                }
            }

            // Initial button state update
            updateButtonState();

            // Update button state after slide change
            $carousel.on("afterChange", function () {
                updateButtonState();
            });

            // Attach prev and next button actions
            $carousel.closest(".carousel-container").find(".prev-btn").click(function () {
                $carousel.slick("slickPrev");
            });

            $carousel.closest(".carousel-container").find(".next-btn").click(function () {
                $carousel.slick("slickNext");
            });
        });
});


  } catch(e) { console.error(e); }
})();
})();
